import styled from 'styled-components';
export const Left = styled.div `
    padding-left: 15px;
    padding-right: 15px;
    width: 75%;
    flex: 0 0 75%;
    max-width: 75%;
`;
export const Right = styled.div `
    padding-left: 15px;
    padding-right: 15px;
    width: 25%;
    flex: 0 0 25%;
    max-width: 25%;
`;
export const Flex = styled.div `
    display: flex;
`;
